const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

/** Distinct sub-category labels already used for a category (slug or ObjectId). */
export async function fetchSubCategoryLabels(category: string): Promise<string[]> {
  if (!category) return [];
  try {
    const res = await fetch(
      `${API_URL}/products/meta/subcategories?category=${encodeURIComponent(category)}`
    );
    const data = await res.json();
    if (data.success && Array.isArray(data.data)) return data.data;
    return [];
  } catch {
    return [];
  }
}
